<template>
  <div class="lp">

    <!-- ===== HERO IMAGE ===== -->
    <section class="lp-hero-img">
      <img src="@/assets/1.jpg" alt="두산위브더제니스 센트럴 천안" />
      <img src="@/assets/2.jpg" alt="두산위브더제니스 센트럴 천안" />
    </section>

    <!-- ===== 사업 개요 ===== -->
    <section class="lp-section lp-overview-head">
      <div class="lp-inner">
        <span class="lp-eyebrow">— O V E R V I E W —</span>
        <h2 class="lp-section-title">
          두산위브더제니스<br/>센트럴 천안<br/>
          <em>사업 개요</em>
        </h2>
        <div class="lp-gold-line"></div>
      </div>
    </section>

    <!-- ===== OVERVIEW ROLLING ===== -->
    <section class="lp-ovslider">
      <div class="ovs-viewport">
        <div
          class="ovs-slide"
          v-for="(src, i) in overviewSlides"
          :key="i"
          :class="{ active: activeSlide === i }">
          <img :src="src" :alt="`두산위브더제니스 센트럴 천안 조감도 ${i + 1}`" />
        </div>
      </div>
      <div class="ovs-dots">
        <button
          v-for="(src, i) in overviewSlides"
          :key="i"
          class="ovs-dot"
          :class="{ active: activeSlide === i }"
          @click="goSlide(i)"
          :aria-label="`${i + 1}번째 조감도 보기`"></button>
      </div>
    </section>

    <!-- ===== 사업 개요 - 데이터 ===== -->
    <section class="lp-section lp-overview">
      <div class="lp-inner">
        <dl class="ov-list">
          <div class="ov-row" v-for="(it, i) in overviewItems" :key="i">
            <dt class="ov-label">{{ it.label }}</dt>
            <dd class="ov-value" v-html="it.value"></dd>
          </div>
        </dl>
      </div>
    </section>

    <!-- ===== LOCATION (입지환경) ===== -->
    <section class="lp-section lp-location">
      <div class="lp-inner">
        <span class="lp-eyebrow">— L O C A T I O N —</span>
        <h2 class="lp-section-title">
          삼성이 선택한 천안 청당,<br/>
          <em>최적의 입지환경</em>
        </h2>
        <div class="lp-gold-line"></div>

        <ul class="loc-list">
          <li class="loc-item" v-for="(it, i) in locationItems" :key="i">
            <span class="loc-num">0{{ i + 1 }}</span>
            <div class="loc-text">
              <h3 class="loc-title">{{ it.title }}</h3>
              <p class="loc-desc" v-html="it.desc"></p>
            </div>
          </li>
        </ul>

        <figure class="loc-map">
          <img src="@/assets/4.jpg" alt="두산위브더제니스 센트럴 천안 입지도" />
        </figure>
      </div>
    </section>

    <!-- ===== THE PREMIUM 4 ===== -->
    <section class="lp-section lp-ultimate">
      <div class="lp-inner">
        <span class="lp-eyebrow light">— T H E &nbsp; P R E M I U M —</span>
        <h2 class="lp-section-title white">
          두산위브더제니스<br/>센트럴 천안을 완성하는<br/>
          <em>네 가지 프리미엄</em>
        </h2>
        <div class="lp-gold-line"></div>

        <div class="ult-grid">
          <article class="ult-card" v-for="(it, i) in ultimateItems" :key="i">
            <header class="ult-card-head">
              <span class="ult-num">0{{ i + 1 }}</span>
              <span class="ult-tag">{{ it.tag }}</span>
            </header>
            <h3 class="ult-title">{{ it.title }}</h3>
            <div class="ult-line"></div>
            <p class="ult-desc" v-html="it.desc"></p>
          </article>
        </div>
      </div>
    </section>

    <!-- ===== PLOT PLAN ===== -->
    <section class="lp-section lp-plot">
      <div class="lp-inner center">
        <span class="lp-eyebrow">— P L O T &nbsp; P L A N —</span>
        <h2 class="lp-section-title">
          총 1,202세대, 10개동의<br/>
          <em>단지 배치</em>
        </h2>
        <div class="lp-gold-line"></div>

        <p class="plot-lead">
          지하 2층 ~ 지상 29층, <strong>두산위브더제니스 센트럴 천안</strong>의 단지 구성을 한눈에.
        </p>

        <div class="plot-item">
          <h3 class="plot-subtitle">단지 배치도</h3>
          <figure class="plot-fig">
            <img class="plot-img" src="@/assets/단지배치도.jpg" alt="두산위브더제니스 센트럴 천안 단지배치도" />
          </figure>
        </div>

        <div class="plot-item">
          <h3 class="plot-subtitle">동호 배치도</h3>
          <figure class="plot-fig">
            <img class="plot-img" src="@/assets/동호배치도.jpg" alt="두산위브더제니스 센트럴 천안 동호배치도" />
          </figure>
        </div>

        <p class="plot-cap">※ 본 배치도는 이해를 돕기 위한 자료이며 실제와 다를 수 있습니다.</p>
      </div>
    </section>

    <!-- ===== COMMUNITY ===== -->
    <section class="lp-section lp-amenity">
      <div class="lp-inner center">
        <span class="lp-eyebrow">— C O M M U N I T Y —</span>
        <h2 class="lp-section-title">
          단지를 넘어선<br/>
          <em>거주의 정원</em>
        </h2>
        <div class="lp-gold-line"></div>

        <figure class="community-fig">
          <img src="@/assets/커뮤니티.jpg" alt="두산위브더제니스 센트럴 천안 커뮤니티 시설" />
        </figure>
      </div>
    </section>

    <!-- ===== UNIT ===== -->
    <section class="lp-section lp-unit">
      <div class="lp-inner center">
        <span class="lp-eyebrow">— U N I T &nbsp; P L A N —</span>
        <h2 class="lp-section-title">
          전 세대 전용 84㎡,<br/>
          <em>3가지 평면</em>
        </h2>
        <div class="lp-gold-line"></div>

        <div class="unit-tabs">
          <button
            v-for="(u, i) in unitTypes"
            :key="u.label"
            class="unit-tab"
            :class="{ active: activeUnit === i }"
            @click="setUnit(i)">
            <span class="ut-label">{{ u.label }}</span>
          </button>
        </div>

        <div class="unit-img-wrap">
          <img
            :src="getUnitImg(unitTypes[activeUnit].image)"
            :alt="unitTypes[activeUnit].label + ' 평면도'"
            class="unit-img"
            :class="{ 'is-loading': unitLoading }"
            @load="onUnitImgLoad"
          />
          <transition name="unit-fade">
            <div v-if="unitLoading" class="unit-loading">
              <span class="unit-spinner"></span>
              <span class="unit-loading-label">LOADING</span>
            </div>
          </transition>
        </div>
      </div>
    </section>

    <!-- ===== 분양 조건 ===== -->
    <section class="lp-section lp-offer">
      <div class="lp-inner center">
        <span class="lp-eyebrow">— S P E C I A L &nbsp; O F F E R —</span>
        <h2 class="lp-section-title">
          이런 조건<br/>
          <em>다시는 안 나옵니다</em>
        </h2>
        <div class="lp-gold-line"></div>

        <ul class="offer-grid">
          <li class="offer-card offer-hero">
            <span class="offer-label">계약금</span>
            <span class="offer-value">ZERO</span>
            <span class="offer-sub">계약금 500만원 → 계약축하금 500만원 지급 · 실부담 0원</span>
          </li>
          <li class="offer-card">
            <span class="offer-label">중도금 이자</span>
            <span class="offer-value">ZERO</span>
          </li>
          <li class="offer-card">
            <span class="offer-label">계약축하금</span>
            <span class="offer-value">500<small>만원</small></span>
          </li>
          <li class="offer-card">
            <span class="offer-label">주택형</span>
            <span class="offer-value">전용 84<small>㎡</small></span>
          </li>
          <li class="offer-card">
            <span class="offer-label">세대수</span>
            <span class="offer-value">1,202<small>세대</small></span>
          </li>
        </ul>

        <p class="offer-extra">
          단지 내 <strong>종로엠스쿨</strong> · <strong>25m 수영장·골프연습장</strong> 등 대형 커뮤니티 완비
        </p>
      </div>
    </section>

    <!-- ===== RESERVATION CTA ===== -->
    <section class="lp-section lp-cta">
      <div class="lp-inner narrow center">
        <span class="lp-eyebrow light">— R E S E R V A T I O N —</span>
        <h2 class="lp-section-title white">
          지금 방문 예약하면<br/>
          <em>특별한 혜택</em>까지
        </h2>
        <div class="lp-gold-line"></div>

        <p class="cta-desc">
          두산위브더제니스 센트럴 천안은 <strong>철저한 예약제</strong>로 운영됩니다.<br/>
          방문 예약 후 계약 고객님께 <strong>500만원 계약축하금</strong>을 지급합니다.
        </p>

        <button class="cta-btn" @click="openRegister">
          <span class="cta-btn-en">PRIVATE RESERVATION</span>
          <span class="cta-btn-kr">방문 예약하기</span>
          <span class="cta-btn-arrow">→</span>
        </button>

        <p class="cta-note">
          ※ 본 사이트는 두산위브더제니스 센트럴 천안 분양 상담 및 방문 예약 안내 페이지입니다.<br/>
          시행사·시공사의 공식 홈페이지가 아닙니다.
        </p>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  name: 'MainView',
  data() {
    return {
      ultimateItems: [
        { tag: 'BRAND VALUE', title: '단 하나의 존재 자체로 완성되는 희소가치', desc: '약 <strong>1.3만여 세대 행정타운 내 유일한 하이엔드 브랜드</strong>로, 천안을 대표할 두산위브더제니스 브랜드 프리미엄.' },
        { tag: 'DESIGN', title: '삶의 수준을 높이는 독보적 특화설계', desc: '<strong>4Bay · 3면 개방형(일부 세대) · 유리난간 · 부분 커튼월룩</strong> 등 차별화 설계와 약 <strong>3,500㎡ 규모 대형 커뮤니티</strong> 시설.' },
        { tag: 'EDUCATION', title: '걸어서 등교하는 안심 도보 통학권', desc: '도보 약 <strong>5분 거리 청당초등학교</strong> + <strong>청당·청수 행정타운 학원가</strong> 인접, 보다 안전하고 우수한 교육환경.' },
        { tag: 'INFRA', title: '삶의 모든 영역이 가까운 완성형 주거 인프라', desc: '<strong>행정타운·산업단지 인접 직주근접</strong> 입지 + <strong>갤러리아 백화점·홈플러스·이마트</strong> 등 풍부한 주거 인프라.' },
      ],

      overviewItems: [
        { label: '단지명',   value: '두산위브더제니스 센트럴 천안' },
        { label: '사업명',   value: '천안 청당 새텃말지구 공동주택 신축공사' },
        { label: '위치',     value: '충청남도 천안시 동남구 청당동 310-6번지 일원' },
        { label: '단지규모', value: '지하 2층 ~ 지상 (최고) 29층 10개동<br/>공동주택 및 부대복리시설' },
        { label: '세대수',   value: '총 1,202세대<br/>(84A 730세대 · 84B 257세대 · 84C 215세대)' },
        { label: '타입',     value: '84A · 84B · 84C' },
      ],

      locationItems: [
        { title: '광역 교통망', desc: '<strong>천안대로·남부대로</strong>로 남천안IC까지 빠른 연결 + <strong>천안역·천안아산역(KTX·SRT)</strong> 손쉬운 이용.' },
        { title: '청당초 초품아', desc: '<strong>청당초 배정 초품아</strong>로 안심 등굣길 + 단지 내 <strong>종로엠스쿨</strong>까지 걸어서 끝내는 교육환경.' },
        { title: '청수행정타운 생활권', desc: '<strong>법원·검찰청 청수행정타운</strong> 인접 + <strong>이마트·하나로마트·롯데시네마</strong> 원스톱 생활인프라.' },
        { title: '천안의 미래가치', desc: '<strong>삼성 1,000조 투자</strong> 수혜권 + <strong>청수역 신설 추진</strong>, 앞으로가 더 기대되는 입지.' },
      ],

      unitTypes: [
        { label: '84A', image: '84A.jpg' },
        { label: '84B', image: '84B.jpg' },
        { label: '84C', image: '84C.jpg' },
      ],
      activeUnit: 0,
      unitLoading: true,

      // 사업개요 조감도 롤링
      overviewSlides: [
        require('@/assets/overview-01.jpg'),
        require('@/assets/overview-02.jpg'),
        require('@/assets/overview-03.jpg'),
        require('@/assets/overview-04.jpg'),
        require('@/assets/overview-05.jpg'),
        require('@/assets/overview-06.jpg'),
        require('@/assets/overview-07.jpg'),
      ],
      activeSlide: 0,
      slideTimer: null,
    }
  },
  mounted() {
    this.preloadUnitImages()
    this.startSlideShow()
  },
  beforeUnmount() {
    this.stopSlideShow()
  },
  methods: {
    openRegister() {
      window.dispatchEvent(new Event('open-register-popup'))
    },
    startSlideShow() {
      this.stopSlideShow()
      this.slideTimer = setInterval(() => {
        this.activeSlide = (this.activeSlide + 1) % this.overviewSlides.length
      }, 3800)
    },
    stopSlideShow() {
      if (this.slideTimer) {
        clearInterval(this.slideTimer)
        this.slideTimer = null
      }
    },
    goSlide(i) {
      this.activeSlide = i
      this.startSlideShow()
    },
    getUnitImg(name) {
      return require('@/assets/unit/' + name)
    },
    setUnit(idx) {
      if (this.activeUnit === idx) return
      this.unitLoading = true
      this.activeUnit = idx
    },
    onUnitImgLoad() {
      this.unitLoading = false
    },
    preloadUnitImages() {
      this.unitTypes.forEach(u => {
        const img = new Image()
        img.src = require('@/assets/unit/' + u.image)
      })
    }
  }
}
</script>

<style scoped>
/* ==================== ROOT ==================== */
.lp {
  background: #ffffff;
  color: var(--le-ink);
  font-family: var(--font-sans);
  letter-spacing: -0.01em;
  overflow-x: hidden;
}

.lp em {
  font-family: var(--font-serif-en);
  font-style: italic;
  font-weight: 400;
  color: var(--le-champagne-dark);
}

.lp strong { font-weight: 600; color: var(--le-noir); }

/* 어절 단위 줄바꿈 — 어느 화면 폭에서든 단어가 중간에 잘리지 않게 */
.lp h2,
.lp h3,
.lp p,
.lp dd,
.lp .offer-sub {
  word-break: keep-all;
  overflow-wrap: break-word;
}

.lp-inner {
  width: 100%;
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 22px;
}
.lp-inner.narrow { max-width: 760px; }
.lp-inner.center { text-align: center; }

.lp-section {
  padding: 96px 0;
  position: relative;
}

.lp-eyebrow {
  display: block;
  font-family: var(--font-mono-disp);
  font-size: 11px;
  letter-spacing: 0.38em;
  font-weight: 500;
  color: var(--le-champagne-dark);
  margin-bottom: 22px;
  text-align: center;
}
.lp-eyebrow.light { color: var(--le-champagne); }

.lp-section-title {
  font-family: var(--font-serif-kr);
  font-weight: 300;
  font-size: 32px;
  line-height: 1.45;
  color: var(--le-noir);
  letter-spacing: -0.02em;
  margin-bottom: 28px;
  text-align: center;
}
.lp-section-title em {
  font-family: var(--font-serif-en);
  font-weight: 400;
  font-style: italic;
  color: var(--le-champagne-dark);
}
.lp-section-title.white { color: var(--le-ink); }
.lp-section-title.white em { color: var(--le-champagne-dark); }
.lp-section-title.light { font-weight: 200; }

.lp-gold-line {
  width: 60px; height: 1px;
  background: linear-gradient(90deg, rgba(22, 38, 107,0), var(--le-champagne), rgba(22, 38, 107,0));
  margin: 0 auto 40px;
}
.lp-gold-line.short { width: 36px; margin: 18px 0; }

/* ==================== HERO IMAGE ==================== */
.lp-hero-img {
  width: 100%;
  background: #ffffff;
  line-height: 0;
}
.lp-hero-img img {
  display: block;
  width: 100%;
  height: auto;
}

/* ==================== OVERVIEW SLIDER (조감도 롤링) ==================== */
.lp-ovslider {
  width: 100%;
  background: #ffffff;
  padding: 0 0 20px;
}
.ovs-viewport {
  position: relative;
  width: 100%;
  aspect-ratio: 1200 / 849;
  overflow: hidden;
  background: var(--le-noir);
}
.ovs-slide {
  position: absolute;
  inset: 0;
  opacity: 0;
  transition: opacity 1s ease;
  pointer-events: none;
}
.ovs-slide.active {
  opacity: 1;
  pointer-events: auto;
}
.ovs-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.ovs-dots {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 16px 0 4px;
}
.ovs-dot {
  width: 8px;
  height: 8px;
  padding: 0;
  border: none;
  border-radius: 999px;
  background: rgba(22, 38, 107, 0.22);
  cursor: pointer;
  transition: all 0.35s cubic-bezier(0.16, 1, 0.3, 1);
}
.ovs-dot.active {
  width: 24px;
  background: var(--le-champagne);
}

/* ==================== ULTIMATE 8 ==================== */
.lp-ultimate {
  background: #ffffff;
  padding: 120px 0;
  position: relative;
}
.lp-ultimate::before, .lp-ultimate::after {
  content: ''; position: absolute; left: 0; right: 0; height: 1px;
  background: linear-gradient(90deg, transparent, var(--le-champagne), transparent);
}
.lp-ultimate::before { top: 0; opacity: 0.5; }
.lp-ultimate::after { bottom: 0; opacity: 0.5; }

.ult-grid {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 0;
  margin-top: 14px;
  border-top: 1px solid rgba(22, 38, 107,0.18);
  border-left: 1px solid rgba(22, 38, 107,0.18);
}
.ult-card {
  padding: 24px 14px 26px;
  border-right: 1px solid rgba(22, 38, 107,0.18);
  border-bottom: 1px solid rgba(22, 38, 107,0.18);
  position: relative;
  display: flex;
  flex-direction: column;
}
.ult-card-head {
  display: flex; align-items: center; justify-content: space-between;
  margin-bottom: 16px;
}
.ult-num {
  font-family: var(--font-rounded);
  font-size: 14px;
  font-weight: 700;
  color: #ffffff;
  background: var(--le-champagne);
  line-height: 1;
  padding: 8px 12px;
  border-radius: 999px;
  letter-spacing: 0.04em;
}
.ult-tag {
  font-family: var(--font-sans);
  font-size: 10px;
  letter-spacing: 0.18em;
  color: var(--le-champagne);
  font-weight: 700;
  white-space: nowrap;
}
.ult-title {
  font-family: var(--font-rounded);
  font-size: 19px;
  font-weight: 700;
  color: var(--le-ink);
  margin-bottom: 10px;
  letter-spacing: -0.02em;
  line-height: 1.35;
  word-break: keep-all;
}
.ult-line {
  width: 24px; height: 2px;
  background: var(--le-champagne);
  margin-bottom: 14px;
  border-radius: 2px;
}
.ult-desc {
  font-family: var(--font-sans);
  font-weight: 400;
  font-size: 13px;
  line-height: 1.7;
  color: rgba(11,11,15,0.7);
  letter-spacing: -0.01em;
  word-break: keep-all;
  overflow-wrap: break-word;
}
.ult-desc strong {
  color: var(--le-champagne-dark);
  font-weight: 600;
}

/* ==================== OVERVIEW (사업 개요) ==================== */
.lp-overview-head {
  background: #ffffff;
  padding: 80px 0 36px;
}
.lp-overview {
  background: #ffffff;
  padding: 36px 0 90px;
}
.ov-list {
  margin: 8px 0 0;
  padding: 0;
  border-top: 2px solid var(--le-champagne);
  border-bottom: 1px solid rgba(11, 11, 15, 0.08);
}
.ov-row {
  display: grid;
  grid-template-columns: 110px 1fr;
  gap: 16px;
  padding: 18px 4px;
  border-bottom: 1px solid rgba(11, 11, 15, 0.06);
  align-items: start;
}
.ov-row:last-child {
  border-bottom: none;
}
.ov-label {
  font-family: var(--font-rounded);
  font-size: 13px;
  font-weight: 700;
  color: var(--le-champagne-dark);
  letter-spacing: -0.01em;
  line-height: 1.6;
}
.ov-value {
  font-family: var(--font-sans);
  font-size: 14px;
  font-weight: 500;
  color: var(--le-ink);
  line-height: 1.6;
  letter-spacing: -0.01em;
  word-break: keep-all;
  margin: 0;
}

/* ==================== LOCATION (입지환경) ==================== */
.lp-location {
  background: #ffffff;
  padding: 90px 0 110px;
}
.loc-list {
  list-style: none;
  padding: 0;
  margin: 8px 0 0;
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.loc-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 22px 20px;
  background: #ffffff;
  border: 1px solid rgba(22, 38, 107, 0.18);
  border-radius: 16px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.loc-item:hover {
  border-color: var(--le-champagne);
  box-shadow: 0 8px 24px -12px rgba(22, 38, 107, 0.35);
}
.loc-num {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--le-champagne);
  color: #ffffff;
  font-family: var(--font-rounded);
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.02em;
}
.loc-text {
  flex: 1;
  min-width: 0;
}
.loc-title {
  font-family: var(--font-rounded);
  font-size: 18px;
  font-weight: 700;
  color: var(--le-ink);
  margin: 4px 0 8px;
  letter-spacing: -0.02em;
  line-height: 1.3;
  word-break: keep-all;
}
.loc-desc {
  font-family: var(--font-sans);
  font-size: 13px;
  font-weight: 400;
  line-height: 1.7;
  color: rgba(11, 11, 15, 0.7);
  letter-spacing: -0.01em;
  word-break: keep-all;
  overflow-wrap: break-word;
}
.loc-desc strong {
  color: var(--le-champagne-dark);
  font-weight: 600;
}
.loc-map {
  margin: 36px 0 0;
  padding: 0;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid rgba(22, 38, 107, 0.18);
}
.loc-map img {
  display: block;
  width: 100%;
  height: auto;
}

/* ==================== PLOT PLAN ==================== */
.lp-plot {
  background: #ffffff;
  padding: 110px 0 120px;
}
.lp-plot .lp-gold-line {
  margin-left: auto;
  margin-right: auto;
}
.plot-lead {
  font-family: var(--font-serif-kr);
  font-size: 15px;
  font-weight: 300;
  line-height: 1.9;
  color: var(--le-ink);
  text-align: center;
  margin-top: 4px;
  margin-bottom: 36px;
}
.plot-lead strong {
  color: var(--le-champagne-dark, #16266B);
  font-weight: 500;
}
.plot-item {
  margin-top: 30px;
}
.plot-item:first-of-type {
  margin-top: 8px;
}
.plot-subtitle {
  font-family: var(--font-rounded);
  font-size: 15px;
  font-weight: 700;
  color: var(--le-champagne-dark);
  letter-spacing: 0.02em;
  margin-bottom: 14px;
}
.plot-fig {
  margin: 0;
  position: relative;
  padding: 14px;
  background: linear-gradient(180deg, #EEF1F8 0%, #DCE3F2 100%);
  border: 1px solid rgba(22, 38, 107, 0.35);
  box-shadow:
    0 0 0 1px rgba(255,255,255,0.4) inset,
    0 24px 50px -20px rgba(11, 11, 15, 0.18);
}
.plot-fig::before,
.plot-fig::after {
  content: '';
  position: absolute;
  width: 14px; height: 14px;
  border: 1px solid var(--le-champagne, #C9A96B);
  opacity: 0.7;
}
.plot-fig::before { top: 4px; left: 4px; border-right: none; border-bottom: none; }
.plot-fig::after  { bottom: 4px; right: 4px; border-left: none; border-top: none; }
.plot-img {
  display: block;
  width: 100%;
  height: auto;
}
.plot-cap {
  margin-top: 14px;
  font-family: var(--font-sans);
  font-size: 11px;
  color: var(--le-warm-grey, #7A6E5A);
  text-align: center;
  letter-spacing: 0.02em;
}

/* ==================== COMMUNITY ==================== */
.lp-amenity {
  background: #ffffff;
  padding: 110px 0;
}
.lp-amenity .lp-gold-line {
  margin-left: auto;
  margin-right: auto;
}
.community-fig {
  margin: 30px 0 0;
  padding: 0;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid rgba(22, 38, 107, 0.18);
}
.community-fig img {
  display: block;
  width: 100%;
  height: auto;
}

/* ==================== UNIT ==================== */
.lp-unit {
  background: var(--le-pearl);
  padding: 110px 0;
}
.lp-unit .lp-gold-line {
  margin-left: auto;
  margin-right: auto;
}
.unit-tabs {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  margin: 8px 0 28px;
  padding: 4px 0;
  overflow-x: auto;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
}
.unit-tabs::-webkit-scrollbar { display: none; }

.unit-tab {
  flex-shrink: 0;
  background: #ffffff;
  border: 1px solid rgba(22, 38, 107, 0.3);
  padding: 10px 18px;
  cursor: pointer;
  font-family: var(--font-rounded);
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: var(--le-ink);
  border-radius: 999px;
  transition: all 0.25s ease;
}
.unit-tab:hover {
  border-color: var(--le-champagne);
}
.unit-tab.active {
  background: var(--le-champagne);
  border-color: var(--le-champagne);
  color: #ffffff;
  box-shadow: 0 8px 20px -10px rgba(22, 38, 107, 0.5);
}

.unit-img-wrap {
  position: relative;
  width: 100%;
  min-height: 240px;
  background: #ffffff;
  border: 1px solid rgba(22, 38, 107, 0.18);
  border-radius: 16px;
  overflow: hidden;
}
.unit-img {
  display: block;
  width: 100%;
  height: auto;
  transition: opacity 0.35s ease;
}
.unit-img.is-loading {
  opacity: 0.3;
}

.unit-loading {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  pointer-events: none;
}
.unit-spinner {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid rgba(22, 38, 107, 0.2);
  border-top-color: var(--le-champagne, #16266B);
  animation: unitSpin 0.8s linear infinite;
}
.unit-loading-label {
  font-family: var(--font-sans);
  font-size: 10px;
  letter-spacing: 0.42em;
  color: var(--le-champagne-dark, #000830);
  font-weight: 600;
}

@keyframes unitSpin {
  to { transform: rotate(360deg); }
}

.unit-fade-enter-active,
.unit-fade-leave-active {
  transition: opacity 0.3s ease;
}
.unit-fade-enter-from,
.unit-fade-leave-to {
  opacity: 0;
}

/* ==================== SPECIAL OFFER (분양 조건) ==================== */
.lp-offer {
  background: #ffffff;
  padding: 100px 0 110px;
}
.offer-grid {
  list-style: none;
  padding: 0;
  margin: 24px 0 28px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}
.offer-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 22px 16px;
  background: #ffffff;
  border: 1px solid rgba(22, 38, 107, 0.22);
  border-radius: 16px;
  text-align: center;
  min-height: 110px;
}
.offer-card.offer-hero {
  grid-column: span 2;
  background: linear-gradient(135deg, var(--le-champagne), var(--le-champagne-dark));
  border-color: var(--le-champagne-dark);
  color: #ffffff;
  min-height: 130px;
  box-shadow: 0 12px 28px -12px rgba(22, 38, 107, 0.45);
}
.offer-label {
  font-family: var(--font-sans);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.2em;
  color: rgba(11, 11, 15, 0.5);
}
.offer-hero .offer-label {
  color: rgba(255, 255, 255, 0.85);
}
.offer-value {
  font-family: var(--font-rounded);
  font-size: 22px;
  font-weight: 800;
  color: var(--le-ink);
  letter-spacing: -0.02em;
  line-height: 1.1;
}
.offer-hero .offer-value {
  font-size: 28px;
  color: #ffffff;
}
.offer-value sup {
  font-size: 0.6em;
  vertical-align: super;
  margin-left: 2px;
}
.offer-value small {
  font-size: 0.6em;
  font-weight: 700;
  margin-left: 2px;
  opacity: 0.85;
}
.offer-sub {
  font-family: var(--font-sans);
  font-size: 12px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.85);
  letter-spacing: -0.01em;
}
.offer-extra {
  font-family: var(--font-sans);
  font-size: 13px;
  font-weight: 500;
  color: rgba(11, 11, 15, 0.7);
  line-height: 1.7;
  margin-top: 8px;
}
.offer-extra strong {
  color: var(--le-champagne-dark);
  font-weight: 700;
}

/* ==================== CTA ==================== */
.lp-cta {
  background: #ffffff;
  color: var(--le-ink);
  padding: 110px 0 130px;
  position: relative;
  overflow: hidden;
}
.lp-cta::before {
  content: '';
  position: absolute; inset: 0;
  background:
    radial-gradient(ellipse at center, rgba(22, 38, 107,0.08), transparent 60%);
  pointer-events: none;
}
.lp-cta .lp-inner { position: relative; z-index: 2; }
.lp-cta .lp-gold-line { margin-left: auto; margin-right: auto; }
.cta-desc {
  font-family: var(--font-serif-kr);
  font-weight: 400;
  font-size: 16px;
  line-height: 2;
  color: rgba(11,11,15,0.78);
  margin-bottom: 38px;
}
.cta-desc strong {
  color: var(--le-champagne-dark);
  font-weight: 600;
}
.cta-btn {
  background: var(--le-champagne);
  border: 1px solid var(--le-champagne);
  color: #ffffff;
  padding: 22px 30px;
  font-family: inherit;
  cursor: pointer;
  width: 100%;
  max-width: 380px;
  margin: 0 auto;
  display: flex; flex-direction: column; align-items: center; gap: 6px;
  position: relative;
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  overflow: hidden;
}
.cta-btn::before {
  content: '';
  position: absolute; inset: 0;
  background: linear-gradient(135deg, var(--le-champagne-dark), var(--le-champagne));
  transform: translateY(101%);
  transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  z-index: 0;
}
.cta-btn:hover::before { transform: translateY(0); }
.cta-btn > * { position: relative; z-index: 1; }
.cta-btn:hover { color: #ffffff; border-color: var(--le-champagne-dark); }
.cta-btn-en {
  font-family: var(--font-mono-disp);
  font-size: 11px;
  letter-spacing: 0.4em;
  color: #ffffff;
  font-weight: 500;
  transition: color 0.4s;
}
.cta-btn-kr {
  font-family: var(--font-serif-kr);
  font-size: 17px;
  font-weight: 600;
  letter-spacing: 0.04em;
}
.cta-btn-arrow {
  font-family: var(--font-serif-en);
  font-size: 18px;
  margin-top: 4px;
  color: #ffffff;
  transition: all 0.4s;
}
.cta-btn:hover .cta-btn-arrow { transform: translateX(4px); }

.cta-note {
  margin-top: 36px;
  font-family: var(--font-serif-kr);
  font-size: 11px;
  color: rgba(11,11,15,0.45);
  line-height: 1.8;
  font-weight: 400;
}

/* ==================== RESPONSIVE (Tablet+) ==================== */
@media (min-width: 768px) {
  .lp-inner { padding: 0 40px; }
  .lp-section { padding: 130px 0; }

  .lp-section-title { font-size: 44px; margin-bottom: 36px; }
  .lp-eyebrow { font-size: 12px; margin-bottom: 28px; }
  .lp-gold-line { width: 80px; margin-bottom: 56px; }


  .ult-grid {
    grid-template-columns: repeat(2, 1fr);
    border-left: 1px solid rgba(22, 38, 107,0.18);
  }
  .ult-card {
    border-right: 1px solid rgba(22, 38, 107,0.18);
    padding: 50px 32px 56px;
  }
  .ult-title { font-size: 22px; }
}

@media (min-width: 1024px) {
  .lp-section { padding: 160px 0; }
  .lp-section-title { font-size: 52px; }
  .ult-grid { grid-template-columns: repeat(4, 1fr); }
}
</style>
